import {useContext} from "react";
import {UserAttributesContext} from "../context/UserAttributesContextObject.ts";

export const useUserAttributes = () => {
    return useContext(UserAttributesContext);
}